
import Swal from 'sweetalert2';
import axios from 'axios';
import axiosClient from '../admin/services/axiosClient';

export const handleDelete = async (endpoint, onSuccess, data = {}, getDataBack = undefined, headers = {}, onError) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this item? This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await axiosClient.patch(`${endpoint}`, data);

        if (response.code !== 200) {
          throw new Error('Failed to delete the item');
        }

        getDataBack(data)

        Swal.fire('Deleted!', 'The item has been deleted.', 'success');
        if (onSuccess) {
          onSuccess(response.data)

        }; // Call the success callback with response data
      } catch (error) {
        Swal.fire('Error!', 'An error occurred while deleting the item.', 'error');
        if (onError) onError(error); // Call the error callback with error details
      }
    } else {
      if (onError) onError(new Error('User cancelled the operation')); // Handle cancellation
    }
  });
};
